/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Check_State_2Inputs */

const en_how_we_work_check_state_2 = /** @type {(inputs: How_We_Work_Check_State_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask a person`)
};

const lv_how_we_work_check_state_2 = /** @type {(inputs: How_We_Work_Check_State_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jautāt cilvēkam`)
};

/**
* | output |
* | --- |
* | "Ask a person" |
*
* @param {How_We_Work_Check_State_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_check_state_2 = /** @type {((inputs?: How_We_Work_Check_State_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Check_State_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_check_state_2(inputs)
	return en_how_we_work_check_state_2(inputs)
});